import React, { useEffect, useState } from "react";
import {
  ShareAltOutlined,
  UsbOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { Avatar, Card, Spin, Result, message, Button } from "antd";
import axios from "axios";
import localhost from "../../constants/localhost";
import { useNavigate } from "react-router-dom";
import DetailModal from "./detailModal";
import EditModal from "./edit";

const dataTemp = Array(20)
  .fill(null)
  .map((_, index) => {
    return {
      id: index,
      title: "捷途山海L9功能手册",
      content:
        "捷途山海L9，是捷途汽车全新打造的新能源序列首款产品，产品定位“大家庭大七座超混SUV”，搭载奇瑞鲲鹏超能混动C-DM技术，主打空间大、油耗省、动力强的产品优势，覆盖家庭旅行混动出行的使用场景。",
    };
  });

const { Meta } = Card;

const SmartAuditing = () => {
  const [data, setData] = useState(dataTemp);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getData = () => {
    setLoading(true);
    axios
      .post(`${localhost}/manage/materialCreation/queryList`, {
        pageNo: 1,
        pageSize: 200,
      })
      .then((res) => {
        setData(res.data?.list || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    const contentStyle = {
      padding: 50,
      background: "rgba(0, 0, 0, 0.05)",
      borderRadius: 4,
    };
    const content = <div style={contentStyle} />;
    return (
      <Spin tip="Loading" size="large">
        {content}
      </Spin>
    );
  }
  if (!loading && !data.length) {
    return (
      <Result
        icon={<SmileOutlined />}
        title="暂无数据，请先去创作！"
        extra={
          <Button
            type="primary"
            onClick={() => {
              navigate("/creation/creationCenter");
            }}
          >
            去创作
          </Button>
        }
      />
    );
  }

  return (
    <div style={{ height: "100%", overflow: "scroll" }}>
      {data.map((item) => {
        const { title, content, id } = item;
        return (
          <Card
            key={id}
            style={{ width: 290, display: "inline-block", margin: 16 }}
            cover={
              <img
                alt="example"
                src="https://shopimg.jetour.com.cn//cms/20250603/1748918902749.png"
              />
            }
            actions={[
              <DetailModal mode="detail" detail={item} />,
              <a>
                <EditModal detail={item} />
              </a>,
              <a
                onClick={() => {
                  window.navigator.clipboard
                    .writeText(title)
                    .then(() => {
                      message.success("已经复制内容，快去分享吧");
                    })
                    .catch((error) => {
                      console.error("Failed to copy text: ", error);
                    });
                }}
              >
                <ShareAltOutlined style={{ marginRight: 8 }} />
                分享
              </a>,
              <a
                onClick={() => {
                  message.success("正在审核中！");
                }}
              >
                <UsbOutlined style={{ marginRight: 8 }} />
                AI审核
              </a>,
            ]}
          >
            <Meta
              avatar={
                <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=8" />
              }
              title={title}
              description={content}
            />
          </Card>
        );
      })}
    </div>
  );
};
export default SmartAuditing;
